import { call, select } from 'redux-saga/effects';

import { getToken } from 'bus/auth/selectors';
import { getOperators } from 'bus/common/selectors';

import { getOperatorRequestLogin } from 'api/methods/common/operators';
import * as R from 'ramda';

export function* requestOperatorLoginSaga({ payload: { callbacks, operatorOtpuskId } }) {
  const token = yield select(getToken);

  const operators = yield select(getOperators);

  const operator = R.pipe(
    R.find(({
      otpusk_id: otpuskId,
      alternative_otpusk_ids: alternativeOtpuskIds = []
    }) => otpuskId === operatorOtpuskId || alternativeOtpuskIds.includes(String(operatorOtpuskId)))
  )(operators);

  try {
    yield call(getOperatorRequestLogin, token, { pathParams: { operatorId: operator.id } });

    callbacks?.onSuccess();
  } catch (error) {
    callbacks?.onFail(error);
  }
}
